import React, { useState, useEffect } from "react";
import { postNumbaUserSellBuyList } from "../../../api/mypage";
import { GoodsInfo } from "./registeredProperty/goods";
import useInfiniteScroll from "../../../utils/hooks/infinite-scroll/useInfiniteScroll";
import { toast } from "wc-toast";
import MobileFooter from "../../../componant/mobileFooter";

// 나의 등록 매물 정보 메인
function MyListing({mainSeq}) {
  const [goods, setGoods] = useState([]);
  const [rowCount, setRowCount] = useState(10);
  const filteredgoods = goods.filter(data => data.main_seq === mainSeq);

  const { setBottom } = useInfiniteScroll(() => {
    setRowCount((prev) => {
      callSellBuyList(prev + 10);
      return prev + 10;
    });
  });

  // 나의 등록매물 리스트
  const callSellBuyList = (cnt) => {
    postNumbaUserSellBuyList({
      startIdx: 0,
      rowCnt: cnt,
    })
    .then((res) => {
      setGoods(res.resultList);
    })
    .catch((err) => console.log("나의 등록매물 정보 불러오기 서버 오류"));
  };

  useEffect(() => {
    callSellBuyList(rowCount);
  }, []);


  return (
    <>
      <div className="request-transiction my-listing">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="main-heading">
                <h1>나의 등록매물 정보</h1>
              </div>
            </div>
          </div>
          {goods?.length > 0 ? (
            <div>
              {/* 마이페이지에서 상세보기 클릭시 mainSeq로 체크 */}
              {mainSeq !== 0 && mainSeq !== undefined ? (
                filteredgoods?.map((data) => {
                  return (
                    <GoodsInfo
                      data={data}
                      callSellBuyList={callSellBuyList}
                      rowCount={rowCount}
                    />
                  );
                })
              ) : (
                // 마이페이지 상단 탭에서 선택시 모두 보이는 화면
                goods?.map((data) => {
                  return (
                    <GoodsInfo
                      data={data}
                      callSellBuyList={callSellBuyList}
                      rowCount={rowCount}
                    />
                  );
                }))
              }
              {goods.length > 0 && <div ref={setBottom} />}
            </div>
          ) : (
            <div className="mypage_wrapper top-border">
              <div className="container">
                <div className="card_part">
                  <div className="card_box intrestCard d-flex align-items-center py-3 justify-content-center">
                    등록 매물이 없습니다.
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <MobileFooter main={true} />
    </>
  );
}

export default MyListing;
